import { render, staticRenderFns } from "./kendo-bubble.vue?vue&type=template&id=a30841fa&scoped=true"
import script from "./kendo-bubble.vue?vue&type=script&lang=js"
export * from "./kendo-bubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30841fa",
  null
  
)

export default component.exports